import axios from "axios";
import axiosInstance from "./axios.instance";

export const getTokenNen = async (maHuyen: string = "748") => {
  let urlServer = `/maptoken?maHuyen=${maHuyen}`;
  const rp = await axiosInstance.get(urlServer);
  return rp;
};

export const loginGiaData = async (username: string, password: string) => {
  return axios.post("/login", {
    username,
    password,
  });
};

export const checkRole = async (username: string, roleId: number) => {
  return axiosInstance.get(`/role?user=${username}&roleId=${roleId}`);
};
